export const MissionFeeVI = {
  "reasonMissionFee": {
    "column": {
      "name": "Tiêu đề"
    },
    "title": "Công tác phí",
    "breadCrumb": "Quản lý công tác phí",
    "pageHeader": {
      "reasonMissionFee": "Quản lý công tác phí"
    }
  }
}
